import request from '@public/http/request'
import Vue from 'vue'
import { RESPONSE_CODE } from '@public/http/config'

const msgVue = new Vue()

const then = res => {
  const { code } = res
  if (code === RESPONSE_CODE.SUCCESS) {
    return res
  } else {
    msgVue.$message.warning(res.msg)
    return Promise.reject(res)
  }
}

const fetch = function (url, data, option) {
  if (option && option.handle) { return request.apply(null, arguments) }
  return request.apply(null, arguments).then(then)
}
fetch.get = function (url, data, option) {
  if (option && option.handle) { return request.get.apply(null, arguments) }
  return request.get.apply(null, arguments).then(then)
}
fetch.post = function (url, data, option) {
  if (option && option.handle) { return request.post.apply(null, arguments) }
  return request.post.apply(null, arguments).then(then)
}
fetch.download = async function (url, data, option) {
  option = Object.assign(option || {}, { headers: { 'systemtype': 'jms' }, responseType: 'arraybuffer', timeout: 60 * 1000, handle: true })
  const arg = [url, data, option]
  if (option && option.handle) { return request.post.apply(null, arg) }
  return request.post.apply(null, arg).then(then)
}

export default fetch
